// Conversie tussen een ISO-datetimestring (backend) en de waarde die een
// <input type="datetime-local"> nodig heeft (lokale tijd, geen tijdzone).
// Zelfde implementatie als modules/leiderschap/dateUtils.ts.

export function toDatetimeLocalValue(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const offsetMs = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() - offsetMs).toISOString().slice(0, 16);
}

export function fromDatetimeLocalValue(value: string): string {
  return new Date(value).toISOString();
}

/** Korte Nederlandse datum voor lijsten, bv. "20 okt 2026"; leeg bij een ongeldige waarde. */
export function formatShortDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' }).replace('.', '');
}
